export default {
	"commonText": {
		"cancel": "Cancel",
		"confirm": "Confirm",
		"dueSoonTextDescription": "Due today or tomorrow",
		"edit": "Edit",
		"parentAccountTestRestrictionMessage": "You must be logged in as a student to take a test.",
		"save": "Save",
		"title": "Title",
		"unauthorizedAccess": "Unauthorized Access",
		"SMSDisclosure":"By providing your mobile number and agreeing to receiving text messages, you agree to receive school-related text message alerts from {district_desc} (attendance, schedule changes, closures/delays, important updates, and similar school communications). Message frequency varies. Standard message and data rates may apply. Reply STOP to cancel or HELP for help. Consent is not required to receive school services. Your mobile number will not be sold or shared with third parties for marketing purposes.",
		"SMSDisclosureDropdown":"By providing your mobile number and selecting 'Yes' for Receives Text Messages, you agree to receive school-related text message alerts from {district_desc} (attendance, schedule changes, closures/delays, important updates, and similar school communications). Message frequency varies. Standard message and data rates may apply. Reply STOP to cancel or HELP for help. Consent is not required to receive school services. Your mobile number will not be sold or shared with third parties for marketing purposes."
	},
	"MAIN_CONTENT": {
		"Accessibility": {
			"skipToMainContent": "Skip to main content",
			"opensInNewTab": "Opens in a new tab"
		},
		"Announcements": {
			"labelAnnouncements": "Announcements",
			"labelDistrictWideAnnouncement": "District-Wide Announcement",
			"labelLess": "Less",
			"labelMore": "More"
		},
		"App": {
			"genericErrorMessage": "Unable to complete data request. If issues persist, please contact support.",
			"permissionDeniedMessage": "Permission Denied. Account is not attached to any students.",
			"titleCWP": "Sapphire Community Portal"
		},
		"AssessmentScores": {
			"assessment": "Assessment",
			"date": "Date",
			"grade": "Grade",
			"noAssessmentsMessage": "No assessment information is available for this student.",
			"proficiency": "Proficiency",
			"proficient": "Proficient",
			"score": "Score",
			"sideMenuAssessmentScoresLink": "Assessment Scores"
		},
		"AssessmentScoresDetails": {
			"assessmentScoresWithColon": "Assessment Scores: {name}",
			"column": "Column",
			"columnDesc": "Column Desc",
			"score": "Score"
		},
		"AssignmentBin": {
			"attachedFiles": "Attached Files",
			"attachedFilesColon": "Attached Files:",
			"bytesMessage": "{name} ({size} Bytes)",
			"due": "Due: {date}",
			"gradeOverPoints": "{grade}/{points}",
			"hyphen": " - ",
			"mySubmissions": "My Submissions",
			"noAssignmentsInAssignmentBin": "No assignments in assignment bin",
			"seeFeedback": "See Feedback"
		},
		"AssignmentsCarousel": {
			"classPage_dueSoon": "Due today or tomorrow ({count})",
			"reviewTestText": "Review Test",
			"takeTestText": "Take Test"
		},
		"Attendance": {
			"attendanceDescription": "Attendance Description",
			"count": "Count",
			"attendanceCodesCounts":"Attendance Codes Counts",
			"comments": "Comments",
			"dailyCode": "Daily Code",
			"date": "Date",
			"day": "Day",
			"minutes": "Minutes",
			"noAbsenceRecords": "This student has no absences",
			"pendingForm":"Excuse Form Pending",
			"periodAttendance": "Period Attendance",
			"periodAttendanceCodes": "Period Attendance Codes",
			"periodAttendanceCodesIcon": "Show Period Attendance Codes Legend",
			"periodAttendanceCodesLegend": "Period Attendance Codes Legend",
			"periodTooltip": "{date} for period {period}: {code} - {description}",
			"selectedMonthFilter": "Selected Month Filter",
			"selectMonthsToDisplay": "Select Months to Display",
			"showFullYearAllCaps": "Show Full Year",
			"sideMenuAttendanceLink": "Attendance",
			"submitAbsenceForm":"Submit Absence Excuse",
			"youDoNotHaveAccessToThisStudentWithPeriod": "You do not have access to this student.",
			"attendanceDetailsOutAndIn": "Time Out: {out} - Time In: {in}",
			"attendanceDetailsOnlyIn": "Time In: ( {in} )",
			"attendanceDetailsOlyOut": "Time Out: ( {out} )",
			"attendanceDetailsMinutes": " - ({minutes} minutes)"
		},
		"AttendanceSummary": {
			"absencesLabel": "Absences",
			"daysAllCaps": "DAYS",
			"daysAllLowercase": "days",
			"earlyAllCaps": "EARLY",
			"earlyAllLowercase": "early",
			"excusedWithColon": "Excused:",
			"minAllCaps": "MIN",
			"minAllLowercase": "min",
			"tardyAllCaps": "TARDY",
			"tardyAllLowercase": "tardy",
			"tardySlashEarlyDismissal": "Tardy / Early Dismissal",
			"unexcusedWithColon": "Unexcused:",
			"unlawfulWithColon": "Unlawful:"
		},
		"BuildingInformation": {
			"addressWithColon": "Address:",
			"buildingInformation": "Building Information",
			"faxWithColon": "Fax:",
			"phoneWithColon": "Phone:",
			"staffTitle": "{title}:"
		},
		"BusingDetails": {
			"blockWithColon": "Block:",
			"bussingNotesWithColon": "Busing Notes:",
			"bussingStatusWithColon": "Busing Status:",
			"busWithColon": "{period} Bus:",
			"carColorWithColon": "Car Color:",
			"carInformationWithColon": "Car Information:",
			"carNotesWithColon": "Car Notes:",
			"licensePlateWithColon": "License Plate:",
			"makeSlashModelWithColon": "Make/Model:",
			"parkingInformationWithColon": "Parking Information:",
			"permitWithColon": "Permit:",
			"stopWithColon": "Stop:",
			"streetWithColon": "Street:",
			"timeWithColon": "Time:",
			"zoneWithColon": "Zone:"
		},
		"Calendar": {
			"lunchMenuModalTitle": "{date} - {school} lunch menu."
		},
		"ChangeStudentData": {
			"addressCity": "Address City",
			"addressCounty": "Address County",
			"addressLineOne": "Address Line 1",
			"addressLineTwo": "Address Line 2",
			"birthDate": "Birth Date",
			"canSendTextMessages": "Can the school send text messages to the Student Phone number?",
			"canSendVoiceMessages": "Can the school send voice messages to the Student Phone number?",
			"contactLivesWithStudent": "Contact lives with the Student",
			"currentWithColon": "Current: {choice}",
			"emailAddressOne": "Email Address 1",
			"emailAddressThree": "Email Address 3",
			"emailAddressTwo": "Email Address 2",
			"employer": "Employer",
			"firstName": "First Name",
			"householdPhone": "Household Phone",
			"householdPhoneEmergencyCallOrder": "Household Phone Emergency Call Order",
			"isPhoneUnlisted": "Is the Student Phone number unlisted?",
			"lastName": "Last Name",
			"middleName": "Middle Name",
			"occupation": "Occupation",
			"parentsGuardians": "Parents/Guardians",
			"phoneFive": "Phone 5",
			"phoneFiveCanSendTextMessages": "Can the school send text messages to the Phone 5 number?",
			"phoneFiveCanSendVoiceMessages": "Can the school send voice messages to the Phone 5 number?",
			"phoneFiveEmergencyCallOrder": "Phone 5 Emergency Call Order",
			"phoneFiveExtension": "Phone 5 Extension",
			"phoneFiveNumberUnlisted": "Is the Phone 5 number unlisted?",
			"phoneFiveType": "Phone 5 Type",
			"phoneFour": "Phone 4",
			"phoneFourCanSendTextMessages": "Can the school send text messages to the Phone 4 number?",
			"phoneFourCanSendVoiceMessages": "Can the school send voice messages to the Phone 4 number?",
			"phoneFourEmergencyCallOrder": "Phone 4 Emergency Call Order",
			"phoneFourExtension": "Phone 4 Extension",
			"phoneFourNumberUnlisted": "Is the Phone 4 number unlisted?",
			"phoneFourType": "Phone 4 Type",
			"phoneOne": "Phone 1",
			"phoneOneCanSendTextMessages": "Can the school send text messages to the Phone 1 number?",
			"phoneOneCanSendVoiceMessages": "Can the school send voice messages to the Phone 1 number?",
			"phoneOneEmergencyCallOrder": "Phone 1 Emergency Call Order",
			"phoneOneExtension": "Phone 1 Extension",
			"phoneOneNumberUnlisted": "Is the Phone 1 number unlisted?",
			"phoneOneType": "Phone 1 Type",
			"phoneThree": "Phone 3",
			"phoneThreeCanSendTextMessages": "Can the school send text messages to the Phone 3 number?",
			"phoneThreeCanSendVoiceMessages": "Can the school send voice messages to the Phone 3 number?",
			"phoneThreeEmergencyCallOrder": "Phone 3 Emergency Call Order",
			"phoneThreeExtension": "Phone 3 Extension",
			"phoneThreeNumberUnlisted": "Is the Phone 3 number unlisted?",
			"phoneThreeType": "Phone 3 Type",
			"phoneTwo": "Phone 2",
			"phoneTwoCanSendTextMessages": "Can the school send text messages to the Phone 2 number?",
			"phoneTwoCanSendVoiceMessages": "Can the school send voice messages to the Phone 2 number?",
			"phoneTwoEmergencyCallOrder": "Phone 2 Emergency Call Order",
			"phoneTwoExtension": "Phone 2 Extension",
			"phoneTwoNumberUnlisted": "Is the Phone 2 number unlisted?",
			"phoneTwoType": "Phone 2 Type",
			"residentOfCounty": "Resident of County",
			"schoolNotificationMessage": "The school will be notified of any changes made and have a chance to review them before the changes take effect.",
			"sideMenuChangeStudentDataLink": "Change Student Data",
			"state": "State",
			"studentAddressCity": "Student Address City",
			"studentAddressLineOne": "Student Address Line 1",
			"studentAddressLineTwo": "Student Address Line 2",
			"studentAddressState": "Student Address State",
			"studentAddressZip": "Student Address Zip",
			"studentAddressZipExtend": "Student Address Extended Zip",
			"studentEmailAddress": "Student Email Address",
			"studentInformation": "Student Information",
			"studentPhone": "Student Phone",
			"studentPhoneType": "Student Phone Type",
			"title": "Title",
			"township": "Township",
			"zipCode": "Zip Code",
			"zipCodeExtension": "Zip Extension"
		},
		"ClassGlossary": {
			"glossary": "Glossary",
			"studentClassGlossaryTitleCase": "Student Class Glossary",
			"studentGroupGlossaryTitleCase": "Student Group Glossary"
		},
		"ClassGrades": {
			"assignmentDescription": "Assignment Description",
			"assignments": "Assignments",
			"assignmentsAllCaps": "ASSIGNMENTS",
			"assignmentSkills": "Assignment Skill(s)",
			"categories": "CATEGORIES",
			"category": "Category",
			"classAverage": "Class Average",
			"codeOverPoints": "{code}/{points}",
			"codeOverPointsPercent": "{code}/{points} ({percent})",
			"currentGrade": "Current Grade:",
			"currentGradeTitleCase": "Current Grade",
			"currentOverMaxPoints": "{current} / {max}",
			"date": "Date",
			"dateAssigned": "Date Assigned",
			"dateDue": "Date Due",
			"finalAverageNote": "*Total points over possible points may not reflect the student's final average if the teacher sets categories to be a specific percentage of a student's marking period average.",
			"generalComment": "General Comment",
			"grade": "Grade",
			"gradesOverPointsAsterisk": "{grade} / {points}*",
			"markingPeriod": "Marking Period: {code}",
			"markingPeriodAbbreviation": "MP %",
			"maxExtraCredit": "Max Extra Credit",
			"noAssignmentGrades": "This marking period currently does not have any assignments with grades.",
			"noCategoryGrades": "This marking period currently does not have any categories with grades.",
			"percent": "{percent}%",
			"points": "Points:",
			"scoresHigher": "Scores Higher",
			"scoresLower": "Scores Lower",
			"scoresSame": "Scores Same",
			"showBy": "Show by:",
			"skill": "Skill",
			"teacherComments": "Teacher Comments",
			"viewAssignmentTest": "View Assignment/Test",
			"weight": "Weight"
		},
		"classPage": {
			"AssignmentCarousel": {
				"classPage_due": "Due:",
				"classPage_noDueDate": "No due date",
				"classPage_points": "Points",
				"classPage_pointsWithPoints": "{points} Points",
				"classPage_testClosesAt": "Test closes at {time}",
				"classPage_uploadSubmission": "Upload Submission",
			},
			"AssignmentsList": {
				"classPage_action": "Action",
				"classPage_assignmentName": "Assignment Name",
				"classPage_dueDate": "Due Date",
			},
			"ClassItems": {
				"noFilesMessage": "Currently, there are no files in this folder.",
			},
			"ClassNav": {
				"classPage_classHome": "Class Home",
			},
			"Header": {
				"classPage_classMenu": "Class Menu",
				"teacherEmail": "e-mail {teacher}",
			},
			"index": {
				"classPage_courseInfo": "Course Info",
				"classPage_courseSections": "Subsection",
				"classPage_currentGrades": "Current Grades",
				"classPage_gradesFootNote": "** These grades are considered complete and may not reflect the assignments in the teacher's Gradebook.",
				"classPage_gridView": "Grid View",
				"classPage_listView": "List View",
				"classPage_reportsForStudent": "Postings For {student}",
				"classPage_sliderView": "Slider View",
			},
		},
		"commonContent": {
			"attachFile": "Attach a file",
			"attachFiles": "Attach files",
			"classPage_upcomingAssignments": "Upcoming Assignments",
			"classPage_upcomingAssignmentTotal": "total ({count})",
			"closeButton": "Close",
			"currentHeaderLabel": "(current)",
			"definition": "Definition",
			"dropMultipleFiles": "Drop files here to upload",
			"dropSingleFile": "Drop a file here to upload",
			"goBack": "Go Back",
			"homeHeaderLink": "Home",
			"invalidPermissions": "You do not have permission to access this page.",
			"name": "Name",
			"newEntryTitleCase": "New Entry",
			"newEntryTitleCaseWithIcon": "<i class=\"fas fa-plus\"></i> New Entry",
			"newPosts": "New Posts",
			"next": "Next",
			"noLabel": "No",
			"noStudentHasBeenSelectedWithPeriod": "No student has been selected.",
			"previous": "Previous",
			"remove": "Remove",
			"schoolLabel": "School",
			"score": "Score:",
			"selectMultipleFiles": "Select files to upload",
			"selectSingleFile": "Select a file to upload",
			"sideMenuGradeLabel": "Grade:",
			"size": "Size",
			"submit": "Submit",
			"submitButton": "Submit",
			"term": "Term",
			"yesLabel": "Yes"
		},
		"confirmSubmission": {
			"confirmSubmission_submitMessage": "Please click the Submit button below to save any question in progress.",
			"confirmSubmission_timesUp": "Sorry, time's up!",
			"pleaseConfirm": "Please Confirm...",
			"returnToQuestionLink": "Use the <a href=\"#question-nav\">question selection menu</a> to return to a question.",
			"returnToQuestionLinkBegin": "Use the ",
			"returnToQuestionLinkEnd": " to return to a question.",
			"returnToQuestionLinkMiddle": "question selection menu",
			"takeTester_answersNotSaved": "{count} answer(s) not yet saved! You can revisit and save your answers or by submitting the test all unsaved answers will be saved.",
			"takeTester_extraCreditUnanswered": "{count} extra credit question(s) unanswered!",
			"takeTester_itAppearsThatYouHave": "It appears that you have:",
			"takeTester_questionsUnanswered": "{count} question(s) unanswered!",
			"takeTester_readyToSubmit": "If you are ready to submit your test, click the button below.",
			"takeTester_singleSittingMessage": "Once you submit your test, you will not be able to change any answers!"
		},
		"CourseRequestForms": {
			"actions": "Actions",
			"chooseDesiredCourseInParenthese": "(Choose if the desired class is not on this list)",
			"courseNonRepeat": "*Student has already taken this course.",
			"coursePreAssigned": "*This course was pre-assigned and cannot be deselected.",
			"courseAdminPreAssigned":"*This course was pre-assigned and cannot be deselected.",
			"coursePreAssignedDeselectable":"*This course was pre-assigned and can be deselected.",
			"courseAdminPreAssignedDeselectable":"*This course was pre-assigned and can be deselected.",
			"courseRequestFormInstructionStepEight": "Print 2 copies of the Course Selection Form, 1 for your records and 1 for the school.",
			"courseRequestFormInstructionStepFive": "To view \"Electives\", Click on the \"Expand\" button to open the screen and select the courses of interest. If you want an alternative course to the one/s you selected you may click to the right of the course of interest in the column labeled \"alternate\". You may then \"collapse\" the screen when finished and move to another area.",
			"courseRequestFormInstructionStepFour": "\"Mandatory Courses\", will be selected for you at your next grade level.",
			"courseRequestFormInstructionStepNine": "Return the signed school copy to your school",
			"courseRequestFormInstructionStepOne": "Choose the appropriate Grade Level above and click \"Fill Out Course Selection\".",
			"courseRequestFormInstructionStepSeven": "On the resulting Course Request Form check for accuracy and follow any remaining instructions.",
			"courseRequestFormInstructionStepSix": "When you have completed your selections, click on \"Save Course Selection.\"",
			"courseRequestFormInstructionStepThree": "All students must select one course from each of the required disciplines.",
			"courseRequestFormInstructionStepTwo": "Select your courses by clicking in the appropriate boxes. If you make a mistake you can simply deselect the check mark next to the course that you want to delete.",
			"courseTitle": "Course Title",
			"credits": "Credits",
			"creditsWithColon": "Credits: {count}",
			"electiveCourses": "Elective Courses",
			"failedPrerequisites": "*Student has not fulfilled the prerequisites of this course.",
			"fillOutCourseRequestForm": "Fill out course request form",
			"mandatoryCourses": "Mandatory Courses",
			"maximumRequirementsMet": "Maximum credits requirement has been reached. A maximum of {max} credits are allowed. Currently {total} credits have been requested.",
			"minimumCreditsNotMet": "Minimum credits requirement has not been reached. A minimum of {min} credits are allowed. Currently {total} credits have been requested.",
			"moreDetailWithColon": "More Detail:",
			"rankAlternateCouses": "{courseid} - {coursedescription}",
			"rankAlternates": "Rank Alternates",
			"rankAlternatesCredits": "Credits: {credit}",
			"rankAlternatesInstructions": "Use the arrows to sort your preferences for courses. 1 indicates your first choice, 2 second, and so on.",
			"rankAlternatesRank": "{rank}",
			"requiredCourses": "Required Courses",
			"selectCourseRequestForm": "Select Course Request Form",
			"selectCourseRequestFormToComplete": "Select the course request form you want to complete from the list below.",
			"specialRequestNotes": "Special Request Notes",
			"youNeedToChoose": "You need to choose at least {min} course(s) for {department}. You chose {courses}"
		},
		"CoursesAndGradesList": {
			"courseTitle": "Course Title",
			"currentGrade": "Current Grade",
			"duration": "Dur.",
			"periodDays": "Per. (Days)",
			"room": "Room",
			"showNonHyphenGradeClasses": "Show Non-Graded Classes",
			"sideMenuCoursesAndGradesLink": "Courses & Grades",
			"teacher": "Teacher"
		},
		"CurrentSchedule": {
			"rm": "RM",
			"showColorTitleCase": "Show Color",
			"showCourseSectionTitleCase": "Show Course Section",
			"showCourseTimesTitleCase": "Show Course Times",
			"sideMenuCurrentScheduleLink": "Current Schedule"
		},
		"DataForm": {
			"absenceDate":"Absence Date",
			"absenceDateFrom":"Absence Date From",
			"absenceDateTo":"Absence Date To",
			"absenceReason":"Reason for Absence",
			"addressOne": "Address 1",
			"addressTwo": "Address 2",
			"attachDocuments":"Attach Documents",
			"attachmentWithColon": "Attachment:",
			"attendanceDateMessage":"Dates must be greater or equal to today.",
			"attendanceNoDatesMessage":"No Valid Dates Available in Form - School year end date is in the past and this form does not allow past dates..",
			"back": "Back",
			"cellPhone": "Cell Phone",
			"city": "City",
			"contactLivesWithStudent": "Contact Lives With Student",
			"county": "County",
			"currentStepOfTotal": "Step {current} of {total}",
			"dirtyPageCancelText": "Keep Filling Out Form",
			"dirtyPageMessage": "The form has been modified. Are you sure you want to leave without saving changes?",
			"dirtyPageOkText": "Leave Without Saving",
			"dirtyPageTitle": "Unsaved Changes",
			"datePickerMessage": "{field} Date Picker",
			"email": "Email",
			"emergencyCallOrder": "Emergency Call Order",
			"employer": "Employer",
			"ext": "Ext.",
			"faxNumber": "Fax Number",
			"formSubmitted": "Form Submitted!",
			"groupNumber": "Group Number",
			"homePhone": "Home Phone",
			"hospitalPreference": "Hospital Preference",
			"idNumber": "ID Number",
			"insuranceCompany": "Insurance Company",
			"middleName": "Middle Name",
			"number": "Number",
			"occupation": "Occupation",
			"pageNumber": "Pager Number",
			"phoneNumberExtension": "Phone Number Extension",
			"physicianFax": "Physician Fax",
			"physicianFaxExtension": "Physician Fax Extension",
			"physicianFaxNumber": "Physician Fax Number",
			"physicianName": "Physician Name",
			"physicianPhone": "Physician Phone",
			"policyNumber": "Policy Number",
			"receivesVoiceCalls": "Receives Voice Calls",
			"releaseStatus": "Release Status",
			"saveCurrentProgressTitleCase": "Save Current Progress",
			"selectDates":"Select the dates that apply",
			"state": "State",
			"stepNumber": "{str}",
			"successfullySubmitted": "You have successfully submitted the following form",
			"test": "{description}",
			"title": "Title",
			"titleWithFormName": "Student Data Forms - {title}",
			"township": "Township",
			"type": "Type",
			"unlisted": "Unlisted",
			"uploadFilesTitleCase": "Uploaded Files",
			"workPhone": "Work Phone",
			"zipCode": "Zip Code",
			"zipCodeExt": "Zip Code Ext",
			"zipCodeExtension": "Zip code extension"
		},
		"Devices": {
			"activeSince": "Active Since",
			"confirmLogoutMessage": "Are you sure you want to log out of this device?",
			"confirmLogoutTitle": "Log out of this device?",
			"device": "Device",
			"devices": "Devices",
			"devicesDescription1Part1": "You have used the ",
			"devicesDescription1Part2": "option on the Sapphire Login screen and are currently logged in on the devices below. You will remain logged in until you log out of Sapphire on this device.",
			"devicesDescription2": "Some devices and browsers have default settings that might automatically log you out. If you experience unintended logouts, please check your device or browser settings.",
			"lastUsed": "Last Used",
			"lastUsedAt": "Last Used at",
			"logOutDevice": "Log Out Device",
			"manageDevices": "Manage My Logged in Devices",
			"noDevicesMessage": "You currently have no devices logged in with the 'remember me?' option selected.",
			"rememberMe": "Remember me?"
		},
		"Discipline": {
			"actionTaken": "Actions Taken",
			"date": "Date",
			"description": "Description",
			"incidentModalTitle": "{description} Incident - Official Description",
			"infractions": "Infractions",
			"noIncidents": "No incidents to show.",
			"showDescription": "Show Description",
			"sideMenuDisciplineLink": "Discipline"
		},
		"Elective": {
			"alternate": "Alternate",
			"electiveAriaMessage": "Course {title} - Credits: {credits}",
			"electiveAlternateAriaMessage": "Course {title} - Credits: {credits} Alternate",
			"specialAriaMessage": "Special Request"
		},
		"EssayQuestion": {
			"enterYourAnswer": "Enter your answer",
			"minMaxPointsMessage": "Please enter between {min} and {max} characters."
		},
		"Feedback": {
			"feedback": "Feedback",
			"noFeedbackMessage": "Currently no feedback for this assignment."
		},
		"Fees": {
			"balanceOwed": "Balance Owed",
			"balanceOwedToSchoolLabel": "Balance Owed to School: {fee}",
			"date": "Date",
			"fee": "Fee",
			"payment": "Payment",
			"feesWithDescription": "Fees: {description}",
			"RevTrakWebstoreModalTitle": "Choose Your RevTrak Webstore",
			"showAllSchoolYears": "Show all school years",
			"sideMenuFeesLink": "Fees",
			"type": "Type"
		},
		"FileCabinet": {
			"navPanelFileCabinet": "File Cabinet",
			"navPanelReportsSubMenuFileCabinet": "Reports, Sub-Menu File Cabinet",
			"searchReturnedNoResults": "The search returned no results."
		},
		"FilesList": {
			"ariaNewTabMessageWithCat": "File {name} in {cat} category (opens in new tab)",
			"datePosted": "Date Posted",
			"name": "Name"
		},
		"Forum": {
			"editTopic": "Edit Topic",
			"message": "Message",
			"newTopic": "New Topic",
			"noTopicsMessage": "There are currently no topics for this forum.",
			"topicHeader": "{label}:"
		},
		"General": {
			"changeMyAccountSettings": "Change My Account Settings",
			"changeMyPassword": "Change my Password",
			"changeMyPasswordForced": "Your password was reset. Enter your temporary password from your email and your new password to continue.",
			"changeMySecurityQuestion": "Change my security question",
			"confirmNewPasswordStartCaseWithColon": "Confirm New Password:",
			"general": "General",
			"generalAccountSettings": "General Account Settings",
			"languageSelectionTitle": "Select a Language",
			"newPasswordStartCaseWithColon": "New Password:",
			"oldPasswordStartCaseWithColon": "Old Password:",
			"passwordDoesntMatch": "Confirm password does not match",
			"passwordLengthMessage": "At least {length} characters - the more characters, the better.",
			"passwordMixMessage": "A mixture of letters and numbers.",
			"passwordRequirements": "Password must must have the following characteristics: ",
			"passwordSettingsStartCase": "Password Settings",
			"pinWithColon": "PIN:",
			"securityAnswerStartCaseWithColon": "Security Answer:",
			"securityQuestionSettingsStartCase": "Security Question Settings",
			"securityQuestionStartCaseWithColon": "Security Question:",
			"selectLanguage": "Select Language:"
		},
		"GlossaryIndex": {
			"collapseAllTitleCase": "Collapse All",
			"expandAllTitleCase": "Expand All"
		},
		"GlossaryResults": {
			"attachedFilesTitleCase": "Attached Files",
			"authorWithColon": "Author:",
			"awaitingTeacherApproval": "Awaiting teacher approval.",
			"delete": "Delete",
			"edit": "Edit",
			"editTerm": "Edit-{term}",
			"teacherNote": "Teacher Note"
		},
		"GlossarySearch": {
			"hideAllTotalEntries": "Hide all {count} entries",
			"searchTermsTitleCase": "Search Terms",
			"viewAllTotalEntries": "View all {count} entries"
		},
		"GraduationProgressReport": {
			"course": "Course",
			"CourseWorkRequirements": "Course Work Requirements",
			"CourseWorkRequirementsMet": "{student} has met the {requirement} Requirements for graduation.",
			"CourseWorkRequirementsNotMet": "{student} has not yet met the {requirement} for graduation",
			"credits": "Credits",
			"creditsAllCaps": "CREDITS",
			"creditsEarned": "Credits Earned",
			"creditsInProgress": "Credits In-Progress",
			"creditsRequiredWithColon": "Credits Required:",
			"creditsStillNeededFirstLettersCapatilized": "Credits Still Needed",
			"departmentRequirementsSatisfiedUponCompletion": "Requirement satisfied upon successful completion of In-progress course work.",
			"finalGrade": "Final Grade",
			"grade": "Grade",
			"requirement": "Requirement",
			"requirementHasBeenSatisfiedWithPeriod": "This Requirement Has Been Satisfied.",
			"sideMenuGraduationProgressLink": "Graduation Progress",
			"status": "Status",
			"summary": "Summary",
			"totalCreditsNeededWithColon": "Total Credits Needed: {credits}",
			"totalCreditsRequirement": "Total Credits Requirement",
			"year": "Year"
		},
		"Header": {
			"account": "Account",
			"accountNavLabel": "Account",
			"accountSettingsHeaderLabel": "Account Settings",
			"changeLanguage": "Change Language",
			"currentStudentProfileTitleCase": "Current Student Profile",
			"logoutHeaderLabel": "Log Out",
			"myStudentProfileTitleCase": "My Student Profile",
			"selectAStudent": "Select a Student",
			"sideNavMyStudents": "My Students",
			"studentSelectionNavLabel": "Student Selection",
			"switchToParentView": "Switch to Parent View",
			"switchToStudentView": "Switch to Student View"
		},
		"HelpButton": {
			"clickLinkMessage": "Click link below to continue to help center",
			"goToHelp": "Go to Help Center",
			"helpLink": "Help",
			"note": "Note: To prevent this for next time, please make sure that pop-ups are allowed for Sapphire.",
			"popupBlocked": "Pop-up Blocker Detected."
		},
		"HomePage": {
			"actionsTakenLabel": "Actions Taken",
			"attendanceDescriptionLabel": "Attendance Description",
			"balanceOwedToSchoolLabelNoProp": "Balance Owed: ",
			"classLabel": "Class",
			"commentsLabel": "Comments",
			"completed": "{percent} Completed",
			"CovidSurveyMessage": "If you have not done so today, please fill in the ",
			"dateLabel": "Date",
			"dayLabel": "Day",
			"feesLabel": "Fees",
			"formsAwaitingCompletionLabel": "Forms Awaiting Completion",
			"formStarted": "(Form Started)",
			"gradeMarkingPeriodLabel": "Grade Marking Period",
			"graduationProgressLabel": "Graduation Progress",
			"infractionsLabel": "Infractions",
			"inProgress": "{percent} In Progress",
			"interactiveSchedulesLabel": "Interactive Schedules",
			"itemLabel": "Item",
			"localeSaveError": "Error while saving locale option.",
			"lunchMenuLabel": "Lunch Menu",
			"minutesLabel": "Minutes",
			"nextYearCourseRequestFormButton": "Next Year Course Request Form is Available",
			"noAttendanceFromPastSevenDaysLabel": "No attendance from past 7 days.",
			"noDisciplineFromThePastSevenDays": "No discipline from past 7 days.",
			"noGradeUpdatesFromThePastSevenDays": "No grade updates from past 7 days",
			"nothingForThisWeek": "Nothing for this week.",
			"noTransactionsFromThePastSevenDaysLabel": "No transactions from past 7 days.",
			"paymentsLabel": "Payments",
			"postedLabel": "Posted",
			"recentAttendanceLabel": "Recent Attendance",
			"recentClassPostingsLabel": "Recent Class Postings",
			"recentDisciplineLabel": "Recent Discipline",
			"recentFeesLabel": "Recent Fees",
			"recentGradeUpdatesLabel": "Recent Grade Updates",
			"recentSchoolPostingsLabel": "Recent School Postings",
			"seeAllLabel": "See All",
			"showingAttendanceFromPastSevenDaysLabel": "Showing attendance from past 7 days.",
			"showingDisciplineFromThePastSevenDays": "Showing discipline from past 7 days.",
			"showingGradeUpdatesFromThePastSevenDays": "Showing grade updates from past 7 days",
			"showingLabel": "Showing",
			"showingTransactionsFromThePastSevenDaysLabel": "Showing transactions from past 7 days.",
			"teacherLabel": "Teacher",
			"transactionsLabel": "Transactions",
			"typeLabel": "Type",
			"upcomingAssignments": "Upcoming Assignments",
			"updatedLabel": "Updated",
			"windowOpenUntilLabel": "Window Open Until"
		},
		"IncompleteForms": {
			"clearFormStartCase": "Clear Form",
			"formsAwaitingCompletionTitleCase": "Forms Awaiting Completion"
		},
		"InteractiveScheduler": {
			"allDepartments": "All Departments",
			"courseConflictMessage": "Oops... it appears your selected course conflicts with another course!",
			"confirmAddClassMessage": "Are you sure you wish to add this class?",
			"confirmAddClassOkText": "Add Class",
			"confirmAddClassTitle": "Add Class?",
			"empty": "(empty)",
			"filterBy": "Filter by:",
			"loadingMessage": "Loading schedule configuration...",
			"periodDays": "Periods / Days",
			"print": "Print",
			"schedulingConflictTitle": "Scheduling Conflict",
			"schedulingConflictMessage": "Class could not be added.",
			"studentSchedule": "student schedule",
			"selectScheduleToAccess": "Select which schedule you want to access.",
			"showCourseDesctions": "Show Course Descriptions",
			"showUnavailableClasses": "Show Unavailable Classes",
			"sideMenuInteractiveSchedulerLink": "Interactive Scheduler",
			"useThisScreenToChangeClassSchedule": "Use this screen to make changes to your class schedule."
		},
		"LTILaunch": {
			"go": "Go"
		},
		"LunchMenus": {
			"lunchMenusLabel": "Lunch Menus"
		},
		"MatchingQuestion": {
			"correctAnswer": "Correct Answer:",
			"instruction": "Match each prompt with it's correct answer.",
			"pointsPossible": "{points} pts possible",
		},
		"MultipleChoiceQuestion": {
			"incorrectMessage": "Incorrect answers will take points away!",
			"pointsPossible": "{points} pts possible",
			"selectAllMessage": "Select ALL correct answers.",
			"selectCorrectMessage": "Select the correct answer."
		},
		"Notifications": {
			"addEmail": "Add email",
			"addNewStep": "Add new step",
			"addSMSTextMessage": "Add SMS Text Message",
			"addVoiceCall": "Add Voice Call",
			"answeredBy": "Answered by:",
			"broadcastHistoryText": "Broadcast History",
			"broadcastsTabName": "My Broadcast History",
			"contactAt": "Contact at",
			"custom": "Custom:",
			"customMessage": "Workflow is customized per subscription type, if no workflow is supplied the system will fall back to the user's default and then the system default.",
			"defaultEmailText": "Default Email Message Language:",
			"defaultNotifications": "Default Notification Workflow",
			"defaultSMSText": "Default SMS Text Language:",
			"defaultVoiceText": "Default Voice Call Language:",
			"dirtyPageCancelText": "Keep Editing",
			"dirtyPageMessage": "One or more changes have not been saved. Are you sure you want to leave without saving?",
			"dirtyPageOkText": "Leave Without Saving",
			"dirtyPageTitle": "Unsaved Changes",
			"districtAnnouncements": "District/School Announcements",
			"duration": "Duration:",
			"email": "Email",
			"emailAllCaps": "EMAIL",
			"emailWithColon": "Email:",
			"globalSetting": "Global Setting",
			"languageSettings": "Language Settings",
			"myDefault": "My Default:",
			"myDefaultMessageText": "Workflow is based on user defined default subscription workflow.",
			"noAudioSupport": "Your browser does not support the audio element.",
			"noBroadcastMessage": "No Broadcasts were found within the last 3 months",
			"notifications": "Notifications",
			"notificationsTabName": "Notification Workflow",
			"notificationsText": "Sapphire Notifications Subscriptions",
			"phone": "Phone:",
			"phoneMessage": "Phone Message:",
			"receiveNotificationsForTheFollowing": "Receive an Email Notification when the following items are posted:",
			"showEnglish": "Show English",
			"sms": "SMS",
			"smsTextMessage": "SMS Text Message",
			"smsTextMessageWithColon": "SMS Text Message:",
			"studentClassReports": "Student/Class Reports",
			"subjectLineWithColon": "Subject Line:",
			"subscribed": "Subscribed",
			"systemDefault": "System Default:",
			"systemDefaultMessageText": "Workflow is based off of Sapphire's system default workflow setting.",
			"turnOffNotificationsViaEmail": "Turn on and off the notifications via email",
			"voiceCall": "Voice Call"
		},
		"NumericQuestion": {
			"acceptableAnswers": "Acceptable Answer(s):",
			"instructionMessage": "Enter your numeric answer",
			"numericalLabel": "{first} - {second}",
			"points": "{points} points"
		},
		"ParentHomePage": {
			"emailWithColon": "Email:",
			"goToMyBackpack": "Go to My Backpack for {name}",
			"homePhoneNumberTitleCaseWithColon": "Home Phone Number:",
			"myStudents": "My Students",
			"quickViewTitleCase": "Quick View",
			"schoolContactTitleCaseWithColon": "School Contact:"
		},
		"PaymentPortal": {
			"adminMessage": "Administrators can view payment screens but cannot make payments. Payments must be made through either a parent or student account.",
			"amount": "Amount",
			"back": "Back",
			"balance": "Balance",
			"balanceZero": "Your balance is currently 0. Choose to pay another amount greater than 0.",
			"cardExpiration": "Card Expiration",
			"choosePaymentTo": "Choose Payment To",
			"choosePaymentAmount": "Choose Payment Amount",
			"confirmPayment": "I acknowledge a payment of {amount} will be submitted through Vanco Payments.",
			"creditDebitCard": "Credit Or Debit Card",
			"date": "Date",
			"fullNameOnCreditCard": "Full Name On Credit Card",
			"ID": "ID",
			"legalNotice": "Please note: All payments are processed through Vanco's payment services. Please contact your school district for any questions regarding payments.",
			"legalNoticeContact": "Contact Information",
			"legalNoticeFooter": "All payments are being processed by Vanco Payment Services. This external payment system is a third-party owned and operated system and has its own privacy policies and terms of use. SapphireK12 is not responsible for supporting that system in any way. Kindly contact your school district if experiencing any difficulties in processing your payments. Please refer to the Sapphire Website for further details regarding this relationship.",
			"nextPaymentInformation": "Next: Payment Information",
			"otherAmount": "Other",
			"otherAmountBlank": "You must enter a value when paying other amount",
			"otherAmountGreaterThanBalance": "<b>Warning</b> - You entered an amount greater than your balance. If you still want to pay this amount, continue to the <b>Payment Information screen.</b> If not, click <b>Close</b>.",
			"otherAmountZero": "You must enter an amount greater than 0.",
			"paymentDetails": "Payment Details",
			"paymentError": "Payment Error!",
			"paymentInformation": "Payment Information",
			"paymentProcessing": "Payment Processing",
			"paymentSuccessful": "Payment Successful!",
			"receiptEmailedTo": "Receipt Emailed To",
			"reference": "Reference",
			"school": "School",
			"submitPayment": "Submit Payment",
			"vancoPaymentPortal": "Payment Portal",
			"zipCode": "Zip Code"
		},
		"Post": {
			"backToTopics": "Back To Topics",
			"comment": "Comment",
			"editPost": "Edit Post",
			"forumLoadedAt": "Forum last refreshed at {date}",
			"hideReplies": "Hide Replies",
			"newComment": "New Comment",
			"placeholder": "RE: {title}",
			"refresh": "Refresh",
			"reply": "Reply",
			"showNReplies": "Show {count} replies",
			"showOneReply": "Show 1 reply"
		},
		"ProgressBar": {
			"completed": "{percent}% Completed",
			"inProgress": "{percent}% In Progress"
		},
		"ProgressReportDepartments": {
			"inProgress": "In Progress",
			"noCoursesQualifyRequirementWithPeriod": "No courses currently qualify for this requirement."
		},
		"ProgressReportYears": {
			"schoolYearWithColon": "School Year: {year}"
		},
		"QuestionGroup": {
			"message": "There is additional information for this question."
		},
		"QuestionSummary": {
			"correct": "Correct",
			"incorrect": "Incorrect",
			"is": "is",
			"partiallyCorrect": "Partially Correct",
			"ptsEarned": "pts earned",
			"yourAnswer": "Your answer"
		},
		"ReportFiles": {
			"ariaNewTabMessage": " (opens in new tab)",
			"datePosted": "Date Posted",
			"name": "Name",
			"navPanelLetters": "Letters",
			"navPanelProgressReports": "Progress Reports",
			"navPanelReportsSubMenuLetters": "Reports, Sub-Menu Letters",
			"navPanelReportsSubMenuProgressReports": "Reports, Sub-Menu Progress Reports",
			"navPanelReportsSubMenuReportCards": "Reports, Sub-Menu Report Cards",
			"navPanelReportsSubMenuTranscript": "Reports, Sub-Menu Transcript",
			"navPanelReportCards": "Report Cards",
			"navPanelTranscript": "Transcript",
			"school": "School"
		},
		"Required": {
			"tootTipMessage": "You may only choose {required} course(s) for {description}. You chose {count}"
		},
		"SessionTimeoutModal":{
			"sessionTimeoutModalTitle": "Warning your session is about to end due to inactivity.",
			"sessionTimeoutModalMessage": "You have been idle for to long. You will be logged out in <strong>{remainingTimeInSession} minutes</strong></span> if you do not take an action. Choose below to logout out or remain logged in."
		},
		"ShortFillQuestion": {
			"enterMessage": "Enter your short answer",
			"ptsPossible": "pts possible"
		},
		"SidePanel": {
			"mainNavLabel": "Main",
			"navPanelReports": "Reports",
			"sideMenuCollapseLabel": "Collapse Menu",
			"sideMenuCourseRequestFormLink": "Course Request Form",
			"sideMenuExpandLabel": "Expand Menu",
			"sideMenuMyBackpackHeader": "My Backpack",
			"sideMenuReportsLink": "Reports"
		},
		"StudentCalendar": {
			"day": "day",
			"dueDateTitleCaseWithColon": "Due Date:",
			"list": "list",
			"month": "month",
			"sideMenuStudentCalendarLink": "Student Calendar",
			"startDateTitleCaseWithColon": "Start Date:",
			"today": "today",
			"week": "week"
		},
		"StudentDataForms": {
			"approvedMessageText": "This form has been approved.",
			"approvedTitleCase": "Approved",
			"completedTitleCase": "Completed",
			"daysTitleCase": "Days",
			"deleteFormMessage": "Are you sure you want to delete this form?",
			"deleteFormOkText": "Delete Form",
			"deleteFormTitle": "Delete Form?",
			"declinedMessageText": "This form has been declined:",
			"declinedTitleCase": "Declined",
			"descriptionLabel": "Description",
			"formLabel": "Form",
			"formsAwaitingCompletionTitleCase": "Forms Awaiting Completion",
			"lastSubmittedTitleCase": "Last Submitted",
			"lastTitleCase": "Last",
			"noFormsAwaitingCompletion": "No forms awaiting completion",
			"onDemandFormsTitleCase": "On Demand Forms",
			"openUntilTitleCase": "Open Until",
			"pendingFormLabel": "Pending Forms",
			"pendingMessageText": "This form is pending approval.",
			"readonlyMessageText":"This form does not accept submissions from administrators.",
			"recentFormLabel": "Recently Completed Forms",
			"resetFormTitleCase": "Clear Form",
			"resultsMessageText": "No recent forms returned",
			"sideMenuStudentDataFormsLink": "Student Data Forms",
			"status": "Status",
			"submittedFormLabel": "Submitted Forms",
			"submittedTitleCase": "Submitted",
			"submissionsTitleCase": "Submissions"
		},
		"StudentInformation": {
			"combinationWithColon": "Combination:",
			"counselorWithColon": "Counselor:",
			"homeroomWithColon": "Homeroom:",
			"learningGroup": "Learning Group:",
			"locationWithColon": "Location:",
			"lockerWithColon": "Locker:",
			"sideMenuGradeLabelEnrolled": "{school} - Grade: {grade}",
			"sideMenuGradeLabelNotEnrolled": "{school} - Grade: {grade} - Not Currently Enrolled",
			"sideMenuStudentInformationLink": "Student Information",
			"teacherWithColon": "Teacher:",
			"team": "Team:"
		},
		"Students": {
			"addAnotherStudent": "Add another student",
			"birthdayDatepickerAccessibilityMessage": "Student birthday date picker",
			"birthdayWithColon": "Birthday:",
			"firstNameWithColon": "First Name:",
			"lastNameWithColon": "Last Name:",
			"manageStudentsTitleCase": "Manage Students",
			"portalAccessInformationalText": "If you want to apply to have Portal access to a different student who is already enrolled in the school district, please click on the button below",
			"requestAccessToOterStudents": "Request access to other students",
			"requestAccessToOtherStudentsTitleCase": "Request Access to Other Students",
			"schoolWithColon": "School:",
			"studentHasAnAccount": "Student has an account",
			"students": "Students",
			"studentsDetailOnWhatToEnter": "Enter the name, birth date, grade, and school below for the students you want to access. A request will be sent to the school district for approval.",
			"submitRequestTitleCase": "Submit Request"
		},
		"Submission": {
			"addSubmission": "Add Submission",
			"assignmentBin": "Assignment Bin",
			"assignmentBinClosed": "*This assignment is currently not open for submissions.",
			"dirtyPageAssignmentMessage": "This assignment has been modified. Are you sure you want to leave without saving changes?",
			"dirtyPageAssignmentTitle": "Unsaved Changes?",
			"dirtyPageAssignmentOkText": "Leave Without Saving",
			"dirtyPageAssignmentCancelText": "Keep Editing",
			"oneFileUpload": "Only one file is allowed to be uploaded",
			"onlyOneSubmission": "*You have reached the limit of 1 submission for this assignments.",
			"submittedFiles": "Submitted Files",
			"textSubmission": "Text Submission",
			"textSubmissionColon": "Text Submission:"
		},
		"testButtons": {
			"takeTester_changeAnswer": "Change Answer",
			"takeTester_flagQuestion": "Flag question",
			"takeTester_saveAnswer": "Save Answer",
			"takeTester_submitTest": "Submit Test"
		},
		"testReviewer": {
			"extraCredit": "Extra Credit",
			"points": "points",
			"reviewMyTest": "Review My Test",
			"scoreOfTotalScore": "{score} of {total}",
			"scoreOfTotalScorePossible": "{score} of {total} possible",
			"scoreOutOfTotal": "{score} / {total}",
			"started": "Started",
			"submitted": "Submitted",
			"takeTester_finishedReview": "When finished reviewing test click the button to close this window."
		},
		"testTaker": {
			"loading": "Loading...",
			"points": "{points} pts.",
			"pointsPossible": "{points} points possible",
			"questionNumber": "Question {number}",
			"takeTester_allowChange": "Students will not be able to change their answers during this test session.",
			"takeTester_availableForReview": "It will be available for reviewing after all tests are graded.",
			"takeTester_closeWindow": "Close Window",
			"takeTester_duration": "Duration",
			"takeTester_immediateFeedback": "Once answers are submitted, feedback will be displayed.",
			"takeTester_mins": "{time} Mins",
			"takeTester_minsLeft": "Minutes Left",
			"takeTester_singleSession": "You must complete this test in a single session",
			"takeTester_startNow": "Start Test Now",
			"takeTester_submitted": "Your test has been submitted!",
			"takeTester_testEndedMessage": "This test has been submitted and you are no longer be able to change any answers.",
			"takeTester_testExpired": "This test is no longer available to be taken.",
			"takeTester_windowCloses": "Window Closes",
			"takeTester_windowOpen": "Window Opens"
		},
		"thirdPartyAccess": {
			"accessGranted": "Access Granted",
			"client": "App/Service",
			"confirmRevokeAccessMessage": "Are you sure you want to revoke this clients access to your account?",
			"confirmRevokeAccessTitle": " Revoke access?",
			"description": "View all third party apps and services that have been granted access. Use the Revoke Access button to end access for an app or service.",			"lastUsed": "Last Used",
			"manageThirdPartyAccess": "Manage Third Party Access for Apps and Services",
			"noClientsMessage": "There are currently no third party apps and services with access.",
			"revokeAccess": "Revoke Access",
			"thirdPartyAccess": "Third Party Access"
		},
		"TimeTraveller": {
			"weekOfWithColon": "Week of:",
			"enterCorrectDateFormat": "Enter correct date format of MM/DD/YYYY",
			"datepickerAriaMessage": "Week of date picker, date format of MM/DD/YYYY"
		},
		"trueFalseQuestion": {
			"questionMessage": "Select either True or False"
		}
	}
};
